import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.jsx";
import SimpleAnalytics from "./components/SimpleAnalytics.jsx";

import "./index.css";

// Import environment debug utility for development
if (import.meta.env.DEV || import.meta.env.VITE_DEBUG_MODE === "true") {
  import("./utils/envDebug.js");
}

// Enable React DevTools in development
if (process.env.NODE_ENV === "development") {
  window.__REACT_DEVTOOLS_GLOBAL_HOOK__ =
    window.__REACT_DEVTOOLS_GLOBAL_HOOK__ || {};
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <SimpleAnalytics />
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>,
);
